/**************************************************
 * toB
 **************************************************/
  const tob = {
  common: {},
  top: {},
  itemList: {},
  itemDetail: {},
  cart: {},
};

/**
* ヘッダーのおすすめアイテム
*/
tob.common.recommendSlider = function() {
  const mySwiper = new Swiper('.js-header-recommend', {
    slidesPerView: 2.6,
    freeMode: {
      enabled: true,// 自由にドラッグ（スワイプ）できるようにする
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
};

/**
* 一括カート追加の際に、カート更新のダイアログを表示
*/
tob.common.cartUpdatePopup = function() {
  const itemCount = document.querySelector('.header__icon--cart');// カート内数量
  const updatedPopup = document.getElementById('cart-updated-popup');// 「カート更新しました」のダイアログ
  
  if (!updatedPopup){
    return;
  }

  // 監視の設定
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      console.log(itemCount);
      // 数量が書き換わったら実行
      showCartPopup();
    });
  });

  // 監視開始（子要素とデータ両方をチェック）
  observer.observe(
    itemCount, { 
      childList: true, 
      characterData: true, 
      subtree: true 
    }
  );

  function showCartPopup() {
    updatedPopup.classList.add('cart-popup-visible');
    updatedPopup.classList.remove('cart-popup-hidden');

    // 3秒後に自動で消す
    setTimeout(() => {
      updatedPopup.classList.remove('cart-popup-visible');
      updatedPopup.classList.add('cart-popup-hidden');
    }, 3000);
  }
}

/**
 * ロゴ縮小の制御
 */
tob.common.headerLogoShrink = function() {
  // 設定値の変数化
  const config = {
    shrinkRatio: 0.7,   // スクロール時のロゴ画像の縮小率
    threshold: 50,      // スクロール量のしきい値（px）
  };

  // ヘッダーロゴ画像
  const logo = document.querySelector('.header__heading-logo');
  if (!logo) {
    return;
  }

  // 1. ページ読み込み時点のロゴの物理的な高さを取得（絶対値を排除）
  const originalHeight = logo.offsetHeight;

  window.addEventListener('scroll', () => {
    // 2. 50px以上スクロールしたら縮小、戻ったら元の高さへ
    if (window.scrollY > config.threshold) {
      logo.style.height = `${originalHeight * config.shrinkRatio}px`;
    } else {
      logo.style.height = `${originalHeight}px`;
    }
  });
}


/**
 * メインビジュアルのスライダー
 */
tob.top.mainvisual = function() {
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//自動再生: true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//自動再生時の静止時間: 4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//スライドアニメーションの速度: 600ms
  const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//左右矢印の表示: true
  const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//ドットの表示: true
  const slideTarget = document.querySelector('.js-home-visual-swiper');//対象のスライド

  // スライドが1枚なら Swiper 自体不要
  const slideCount = slideTarget.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    return;
  }

  // Swiper初期化
  const homeVisualSwiper = new Swiper(slideTarget, {
    slidesPerView: 1,
    speed: slideSpeed,
    // 自動再生
    autoplay: slideAutoplay ? {
      delay: slideAutoplaySpeed,
    } : false,
    allowTouchMove: true,
    loop: slideCount > 1,
    // ナビゲーション（矢印）
    navigation: slideArrow ? {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    } : false,
    // ページネーション（ドット）
    pagination: slideDot ? {
      el: ".swiper-pagination",
      clickable: true,
    } : false,
  });
};

/*
* ========================================
* 初期処理
* ========================================
*/
window.addEventListener('load', function () {
  // ----------------------------------------
  // Common
  // ----------------------------------------  
  // ヘッダーのおすすめアイテムのスライダー
  if($('.js-header-recommend').length){
    tob.common.recommendSlider();
  }

  // 一括カート追加の際に、カート更新のダイアログを表示
  if($('quick-add-bulk').length){
    tob.common.cartUpdatePopup();
  }

  // ロゴ縮小の制御
  if ($('.header__heading-logo').length) {
    tob.common.headerLogoShrink();
  }

  // ----------------------------------------
  // Top
  // ----------------------------------------
  if ($('.page-index').length) {
    // メインビジュアルのスライダー
    if($('.js-home-visual-swiper').length){
      tob.top.mainvisual();
    }
  }

});